import React from "react";
import { MdSchool } from "react-icons/md";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

const Education = () => {
  const educationData = [
    {
      date: "2022 – 2026",
      title: "United College of Engineering and Research",
      subtitle: "B.Tech in Computer Science",
      place: "Prayagraj, Naini",
      detail: null,
    },
    {
      date: "2019 – 2021",
      title: "St. Francis School Ramnagar",
      subtitle: "Intermediate (Class XII)",
      place: "Varanasi",
      detail: "Scored: 91.2%",
    },
    {
      date: "2017 – 2019",
      title: "St. Francis School Ramnagar",
      subtitle: "High School (Class X)",
      place: "Varanasi",
      detail: "Scored: 91.4%",
    },
  ];

  return (
    <section
      id="education"
      className="py-20 px-4 bg-gradient-to-br from-blue-50 to-indigo-50
        dark:from-[#0a0a18] dark:to-[#0f0f1a] transition-colors duration-300"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <h2
            className="text-3xl font-extrabold uppercase tracking-widest
              text-gray-800 dark:text-white mb-3"
            style={{ fontFamily: "'Syne', sans-serif" }}
          >
            Education
          </h2>
          <div className="w-16 h-1 mx-auto rounded-full bg-gradient-to-r from-[#f29f67] to-[#3b8ff3]" />
        </div>

        <VerticalTimeline lineColor="rgba(59,143,243,0.3)">
          {educationData.map((edu, idx) => (
            <VerticalTimelineElement
              key={idx}
              className="vertical-timeline-element--education"
              contentStyle={{
                background: "rgba(255,255,255,0.9)",
                color: "#1e293b",
                borderRadius: "16px",
                boxShadow: "0 4px 24px rgba(59,143,243,0.08)",
                border: "1px solid rgba(59,143,243,0.1)",
              }}
              contentArrowStyle={{ borderRight: "7px solid rgba(255,255,255,0.9)" }}
              date={
                <span className="text-sm font-semibold text-[#3b8ff3] dark:text-[#3b8ff3]">
                  {edu.date}
                </span>
              }
              iconStyle={{
                background: "linear-gradient(135deg, #f29f67, #3b8ff3)",
                color: "#fff",
                boxShadow: "0 0 0 4px rgba(242,159,103,0.2)",
              }}
              icon={<MdSchool />}
            >
              <h3 className="font-bold text-base text-gray-900" style={{ fontFamily: "'Syne', sans-serif" }}>
                {edu.title}
              </h3>
              <h4 className="text-sm font-semibold text-[#3b8ff3] mt-1">{edu.subtitle}</h4>
              <p className="text-xs text-gray-500 mt-1">{edu.place}</p>
              {edu.detail && (
                <span className="inline-block mt-2 px-3 py-1 bg-[#f29f67]/10 text-[#f29f67]
                  rounded-full text-xs font-semibold">
                  {edu.detail}
                </span>
              )}
            </VerticalTimelineElement>
          ))}
        </VerticalTimeline>
      </div>
    </section>
  );
};

export default Education;